<template>
  <div class="my-banner">
    <mt-swipe class="m-banner" :auto="4000">
      <mt-swipe-item v-for="(item, index) in list" :key="index">
        <img :src="item.image" alt title @click="bannerClick(item)" />
      </mt-swipe-item>
    </mt-swipe>
  </div>
</template>

<script>
export default {
  name: "MyBanner",
  data() {
    return {};
  },
  props: {
    list: Array
  },
  methods: {
    // banner跳转  类型：1:无连接 2:超链接 3:图文H5 4:产品 5:分类 6:品牌
    bannerClick(item) {
      if (item.type == 1) {
        return;
      } else if (item.type == 2) {
        window.open(item.url);
      } else if (item.type == 3) {
        // this.dialogTableVisible = true;
        // this.bannerContent = item.content;
        // window.open(process.env.NODE_HOST + 'api/user/basic/agreement/h5/'+item.entity_id)
      } else if (item.type == 4) {
        this.$router.push({
          path: "/mgoodsDetail",
          query: { goods_id: item.entity_id }
        });
      } else if (item.type == 5) {
        this.$router.push({
          path: "/msearchResult",
          query: { cat_id: item.entity_id }
        });
      } else if (item.type == 6) {
        this.$router.push({
          path: "/mbrandDetail",
          query: { brand_id: item.entity_id }
        });
      }
    }
  }
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/pages/mobile/components/MyBanner/index.vue